import { Component } from "react";
import styles from "./show-list-item-overlay.module.less";
import UiBkgImage from "@rnb/ui-bkg-image";
import { extract, DateHelper } from "@parksandresorts/core";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import Label from "components/block-elements/label/label";

export default class ShowListItemOverlay extends Component {
  constructor(props) {
    super(props);

    this.showId = extract(props, "id");
    this.imgUrl = extract(props, "imageInList.file.url");
    this.title = extract(props, "title");
    this.linkUrl = extract(props, "pageLink.slug");
    this.label = extract(props, "label");
    this.extraClass = extract(props, "extraClass", "");
    this.largeCardMobile = extract(props, "largeCardMobile");
    this.events = extract(props, "events");

    this.filteredEvents = this.events
      ? this.events.reduce((array, item) => {
          if (DateHelper.isDateValid(item.startDateAndTime)) {
            array.push(item.startDateAndTime);
          }
          return array;
        }, [])
      : [];
    this.filteredEventsLimit = this.filteredEvents.slice(0, Math.min(1, this.filteredEvents.length));
    this.filteredEventsTimestamps = this.filteredEventsLimit.map((item) => DateHelper.toStringDDMMHHMM(item));
  }

  componentDidMount() {
    //call to scheduleStore to get scheduled time with showId
  }

  render() {
    return (
      <div
        className={[
          styles.wrapper,
          this.largeCardMobile ? styles.largeCardMobile : "",
          this.extraClass ? this.extraClass : "",
        ].join(" ")}
      >
        <LinkWrapper className={styles.link} url={this.linkUrl}>
          <div className={styles.imageWrapper}>
            <UiBkgImage
              className={styles.image}
              smallDeviceImageMaxWidth={600}
              largeDeviceImageMaxWidth={450}
              breakPointSmallDevice={9999}
              backgroundSizing="cover"
              imageUrlForSmallDevice={this.imgUrl}
              imageUrlForLargeDevice={this.imgUrl}
            />
            {this.label && (
              <div className={styles.labelWrapper}>
                <Label title={this.label} />
              </div>
            )}
            <div className={[styles.overlayWrapper].join(" ")} />
          </div>

          <div className={styles.textWrapper}>
            {this.title && <h4 className={styles.headline}>{this.title}</h4>}
            <div className={styles.propertyRow}>
              <span className={["icon-calendar", styles.icon].join(" ")} />
              <span className={[styles.propertyValue, "body-s"].join(" ")}>
                {this.filteredEventsTimestamps && this.filteredEventsTimestamps.join(", ")}
              </span>
            </div>
          </div>
        </LinkWrapper>
      </div>
    );
  }
}
